// /eju/calculator: shows the fields of the way the reader chose. ⛔ Native
// DOM, no React, no figures: the server computes everything.
import { showsWay } from 'utils/examCalculatorForm'

function setup() {
  const form = document.querySelector('[data-eju-form]')
  if (!form) return

  const update = () => {
    const chosen = form.querySelector('[data-eju-way-choice]:checked')?.value || 'self'
    form.querySelectorAll('[data-eju-way]').forEach((group) => {
      const shown = showsWay(group.dataset.ejuWay, chosen)
      group.hidden = !shown
      // A hidden field is not sent, so a stale score cannot reach the server.
      group.querySelectorAll('input, select').forEach((field) => { field.disabled = !shown })
    })
  }

  form.addEventListener('change', update)
  update()
}

document.addEventListener('DOMContentLoaded', setup)
